module.exports = __webpack_public_path__ + "static/media/goggles-orig.ea1ba22b.svg";